import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSellerMode } from '../../contexts/SellerModeContext';
import AiAssistant from '../AiAssistant';
import NotificationBell from '../NotificationBell';
import Sidebar from './Sidebar';
import SellerModeSelector from './SellerModeSelector';
import { List } from '@phosphor-icons/react';

export default function DashboardLayout({ children, title, subtitle, actions }) {
  const { user } = useAuth();
  const { isSellerMode, activeSeller } = useSellerMode();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[#f5f5f7]">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 lg:ml-[260px] min-w-0">
        {/* Seller Mode Banner */}
        {isSellerMode && (
          <div className="bg-[#f6a609] text-white px-4 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm font-semibold shadow-sm" data-testid="seller-mode-banner">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"></path></svg>
            <span className="truncate">Viewing as: <span className="font-bold">{activeSeller?.name}</span> ({activeSeller?.email})</span>
          </div>
        )}

        <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-[#e5e5ea]">
          <div className="flex items-center justify-between px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
            <div className="flex items-center gap-3 min-w-0">
              {/* Mobile hamburger */}
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-1.5 -ml-1 rounded-lg hover:bg-[#f5f5f7] text-[#5a5c87]"
                data-testid="mobile-menu-btn"
              >
                <List size={22} weight="bold" />
              </button>
              <div className="min-w-0">
                <h1 className="font-black text-xl sm:text-2xl text-[#0A0A0A] tracking-tight truncate" data-testid="page-title">{title}</h1>
                {subtitle && <p className="text-xs sm:text-sm text-[#5a5c87] mt-0.5 truncate">{subtitle}</p>}
              </div>
            </div>
            <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
              {user?.role === 'admin' && <div className="hidden sm:block"><SellerModeSelector /></div>}
              <div className="hidden sm:block">{actions}</div>
              <NotificationBell />
            </div>
          </div>
          {/* Mobile-only actions row */}
          {(actions || (user?.role === 'admin')) && (
            <div className="sm:hidden flex items-center gap-2 px-4 pb-2 overflow-x-auto">
              {user?.role === 'admin' && <SellerModeSelector />}
              {actions}
            </div>
          )}
        </header>

        <main className="px-4 sm:px-6 lg:px-8 py-4 sm:py-6">{children}</main>

        <footer className="px-4 sm:px-8 py-4 border-t border-[#e5e5ea] bg-white/50" data-testid="app-footer">
          <p className="text-[11px] text-[#9c9db7] text-center tracking-wide">
            Powered by <span className="font-semibold text-[#464C82]">Vinculum</span> &middot; &copy; {new Date().getFullYear()} Vinculum Group. All rights reserved.
          </p>
        </footer>

        <AiAssistant />
      </div>
    </div>
  );
}
